import axios from './axios'

export default new class {
    async confirmarCodigo(codigo) {
        try {
            const response = await axios.post('/verify-code', {
                code: codigo,
            })

            if (!response || !response.data || !response.data.status || response.data.status != 'success')
                throw new Error('Resposta inválida')

            return true
        }
        catch (error) {
            return false
        }
    }

    async enviarCodigoVerificacao(modo, encryptedContato) {
        try {
            const response = await axios.post('/verification-code', {
                modo,
                encryptedContato,
            })

            if (!response || !response.data || !response.data.status || response.data.status != 'success')
                throw new Error('Resposta inválida')

            return true
        }
        catch (error) {
            return false
        }
    }

    async getMeiosContato(cpfCnpj) {
        try {
            const response = await axios.post('/verification-options', {
                cpfCnpj,
            })

            if (!response || !response.data || !response.data.status || response.data.status != 'success' || !response.data.meiosContato)
                throw new Error('Resposta inválida')

            return response.data.meiosContato
        }
        catch (error) {
            return false
        }
    }

    async checarTermos(cpfCnpj = null) {
        try {
            const response = await axios.post('/check-terms', {
                cpfCnpj,
            })

            if (!response || !response.data || !response.data.status || response.data.status != 'success' || (!response.data.totalTermos && response.data.totalTermos !== 0))
                throw new Error('Resposta inválida')

            return response.data.totalTermos
        }
        catch (error) {
            return false
        }
    }

    async getTermos(cpfCnpj = null) {
        try {

            const response = await axios.post('/list-terms', {
                cpfCnpj,
            })

            if (!response || !response.data || !response.data.status || response.data.status != 'success' || !response.data.termos)
                throw new Error('Resposta inválida')
            
            localStorage.setItem('termos', JSON.stringify(response.data.termos))

            return response.data.termos
        }
        catch (error) {
            return false
        }
    }

    async getPdf(idTermo) {
        try {
            const response = await axios.post('/get-pdf', { idTermo })

            if (!response || !response.data || !response.data.status || response.data.status != 'success' || !response.data.base64Pdf)
                throw new Error('Resposta inválida')

            return response.data.base64Pdf
        }
        catch (error) {
            return false
        }
    }

    async assinarTermo(idTermo) {
        try {
            const response = await axios.post('/sign-term', {
                idTermo,
            })

            const isResponseInvalid = !response?.data?.status || response.data.status !== 'success'
            
            const isTermoAssinado = response?.data?.status === 'error' && response.data.message === 'Este termo já foi assinado'

            if (isResponseInvalid && !isTermoAssinado)
                throw new Error('Resposta inválida')

            return true
        }
        catch (error) {
            return false
        }
    }
}